import styled from "@emotion/styled";

export const Grid: any = styled.div`
  display: grid;
`;
